import { ArrowRight } from "lucide-react";
import { Reveal, SectionHead } from "./Reveal";

const STEPS = [
  { num: "01", t: "Client Brief", d: "A real brief lands. Objectives, audience, budget, mandatories." },
  { num: "02", t: "Moodboard", d: "You build the visual world and defend every reference." },
  { num: "03", t: "Pitch Deck", d: "Present the idea like an agency would — to people who say no." },
  { num: "04", t: "Production", d: "Shoot day. Call sheets, roles, pressure, problem-solving." },
  { num: "05", t: "Rough Cut", d: "First assembly. Notes come back. You revise, not cry." },
  { num: "06", t: "Grade & Mix", d: "Color, sound, finish — the polish that sells the idea." },
  { num: "07", t: "Sign-Off", d: "Client approves. Files delivered. Credit earned. Real." },
];

export const Workflow = () => (
  <section data-testid="workflow-section" className="bg-ink border-y border-line py-28 sm:py-40 overflow-hidden">
    <div className="max-w-[1600px] mx-auto px-5 sm:px-10">
      <SectionHead num="08" eyebrow="The Pipeline" title="Client → Final Delivery" />
    </div>
    <div className="max-w-[1600px] mx-auto px-5 sm:px-10">
      <div className="flex gap-4 overflow-x-auto pb-6 snap-x snap-mandatory [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
        {STEPS.map((s, i) => (
          <Reveal key={s.num} delay={i * 0.06} className="snap-start shrink-0">
            <div
              data-testid={`workflow-step-${s.num}`}
              className="group w-[240px] sm:w-[280px] h-[300px] border border-line bg-obsidian p-6 flex flex-col justify-between hover:border-acid transition-colors duration-300"
            >
              <div className="flex items-start justify-between">
                <span className="font-display font-extrabold text-5xl text-stroke group-hover:text-acid group-hover:[-webkit-text-stroke:0] transition-all duration-300">{s.num}</span>
                {i < STEPS.length - 1 && <ArrowRight className="w-4 h-4 text-dim group-hover:text-acid transition-colors duration-300" strokeWidth={1.5} />}
              </div>
              <div>
                <h3 className="font-head text-lg font-bold uppercase tracking-tight text-cream">{s.t}</h3>
                <p className="mt-3 text-sm text-smoke leading-relaxed">{s.d}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
      <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-dim mt-4">Drag / scroll the pipeline →</p>
    </div>
  </section>
);
